import { SwivuSortedGroupersMixin } from "./mixins/SwivuSortedGroupersMixin";
import { SwivuStoreArchiveMixin } from "./mixins/SwivuStoreArchiveMixin";
import {STORE_KEYS} from "../../other/constants/StoreKeys.jsx";
import { IncentivePoint } from "../models/IncentivePoint.jsx";
import { Store } from "@bryntum/schedulerpro";

export class SwivuIncentivePointsStore extends SwivuSortedGroupersMixin(SwivuStoreArchiveMixin(Store)) {
  static get $name() {
    return "SwivuIncentivePointsStore";
  }

  static get configurable() {
    return {
      id: STORE_KEYS.incentivePointsStore,
      storeId: STORE_KEYS.incentivePointsStore,
      modelClass: IncentivePoint,
    };
  }
}